/**
 * Public support page for https://app.pacarion.com/support.
 * Signed-out visitors can open it. No emoji. Light and dark follow the theme.
 */
import React from 'react';
import { useTheme } from '../ThemeContext';
import Footer from './Footer';
import { COMPANY, followPolicyLink } from '../utils/legal';

export default function SupportPage() {
  const { colors, isDark } = useTheme();
  const linkColor = isDark ? '#5eead4' : '#0f766e';
  return (
    <div
      className="app-scroll"
      data-testid="support-page"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        background: colors.background,
        color: colors.text,
        paddingTop: 'calc(1.5rem + env(safe-area-inset-top, 0px))',
        paddingBottom: 'calc(1.5rem + env(safe-area-inset-bottom, 0px))',
        paddingLeft: 'max(1.25rem, env(safe-area-inset-left, 0px))',
        paddingRight: 'max(1.25rem, env(safe-area-inset-right, 0px))',
      }}
    >
      <main style={{ maxWidth: '32rem', width: '100%', margin: '0 auto', flex: '1 0 auto' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 650, margin: '0 0 1.25rem' }}>Support</h1>
        <p style={{ margin: '0 0 0.35rem', color: colors.textSecondary, fontSize: '0.95rem' }}>Email</p>
        <p style={{ margin: '0 0 1.25rem', fontSize: '1.05rem', lineHeight: 1.5 }}>
          <a href={`mailto:${COMPANY.email}`} style={{ color: linkColor, fontWeight: 650 }}>
            {COMPANY.email}
          </a>
        </p>
        <p style={{ margin: '0 0 0.35rem', color: colors.textSecondary, fontSize: '0.95rem' }}>Mail</p>
        <p style={{ margin: '0 0 1.25rem', fontSize: '1.05rem', lineHeight: 1.5 }}>
          {COMPANY.legalName}
          <br />
          {COMPANY.address}
        </p>
        <p style={{ margin: 0, fontSize: '1.05rem', lineHeight: 1.5 }}>
          <a
            href="/data-deletion"
            onClick={followPolicyLink}
            style={{ color: linkColor, fontWeight: 650, display: 'inline-flex', alignItems: 'center', minHeight: '44px' }}
          >
            How to delete your account
          </a>
        </p>
      </main>
      <Footer />
    </div>
  );
}
